var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGotoChaticon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 23.8333H23.3335V20.4999H10.0002V23.8333ZM10.0002 18.8333H30.0002V15.4999H10.0002V18.8333ZM10.0002 13.8333H30.0002V10.4999H10.0002V13.8333ZM3.3335 37.1666V7.16659C3.3335 6.24992 3.66016 5.46492 4.3135 4.81159C4.96683 4.15825 5.75127 3.83214 6.66683 3.83325H33.3335C34.2502 3.83325 35.0352 4.15992 35.6885 4.81325C36.3418 5.46659 36.6679 6.25103 36.6668 7.16659V27.1666C36.6668 28.0833 36.3402 28.8683 35.6868 29.5216C35.0335 30.1749 34.2491 30.501 33.3335 30.4999H10.0002L3.3335 37.1666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoChaticon);
export default __webpack_public_path__ + "static/media/gotoChat.icon.39cd32a28f48ddfb6d6cb55cc7bd74c3.svg";
export { ForwardRef as ReactComponent };